<script>
import formDialogCreate from '@/components/iglobalwin/formDialog';
import formPanelCreate from '@/components/iglobalwin/form-warps/dialog-form-panel/dialog-form-panel.js';

import tweetsAPI from '@/backend/services/account/tweets';
import { validRequired } from '@/common/elementValid.js';
import mediafax from '@/backend/services/account/mediafax';
import { getDateList } from '@/common/util.js';

import facebookText from './facebookText.vue';
import assetsComponent from './assets.vue';

function getFormData(_obj, vm) {
	let { attributes } = vm;
	let {
		customerId,
		customerName,
		action,
		sendDateTime,
		content,
		assets,
		tiktokTitle,
		videoFile,
		privacyLevel,
		interaction,
		openBrand,
		businessContent,
		serviceOptions,
	} = attributes;

	return {
		customerId: {
			formType: 'customer-search',
			value: customerId || '',
			placeholder: '',
			label: '选择客户',
			defaultKey: customerName,
			options: [],
			rules: [validRequired(), 'change'],
		},
		serviceId: {
			label: '服务单',
			formType: 'sky-select',
			value: '',
			props: {
				label: 'domain',
				value: 'id',
			},
			options: serviceOptions || [],
			setOptionLeftLabel(row) {
				return `${row.domain || '-'}(${row.serviceCode})`;
			},
		},
		platform: {
			label: '社媒平台',
			formType: 'sky-select',
			value: '',
			options: [
				{
					label: 'Facebook',
					value: '26',
				},
				// {
				// 	label: 'Twitter',
				// 	value: '27',
				// },
				// {
				// 	label: 'LinkedIn',
				// 	value: '25',
				// },
				// {
				// 	label: 'YouTube',
				// 	value: '28',
				// },
				{
					label: 'TikTok',
					value: '29',
				},
			],
			visable() {
				return false;
			},
		},
		action: {
			label: '推送类型',
			formType: 'sky-select',
			value: action || 1,
			options: [
				{ label: '实时推送', value: 1 },
				{ label: '定时推送', value: 2 },
			],
			onChange: valueChange,
		},
		sendDateTime: {
			label: '推送时间',
			formType: 'sky-date-picker',
			value: sendDateTime || getDateList(1, 'YYYY-MM-DD HH:mm:ss')[0].value,
			type: 'datetime',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			visable(vm) {
				return vm.formData.fields.action.value == 2;
			},
		},
		content: {
			label: '编辑内容',
			formType: facebookText,
			value: content || '',
			fileChange: list => {
				vm.attributes.assets = list;
			},
			start: () => {
				vm.formData.loading = true;
			},
			end: () => {
				vm.formData.loading = false;
			},
			list: attributes.assets || [],
			visable(vm) {
				return vm.formData.fields.platform.value !== '29';
			},
		},
		assets: {
			formType: assetsComponent,
			value: assets,
			visable(vm) {
				return vm.attributes.assets.length > 0 && vm.formData.fields.platform.value !== '29';
			},
		},
		videoFile: {
			label: '视频',
			formType: 'sky-uploadImg',
			accept: 'video/*',
			limit: 1,
			drag: true,
			value: videoFile ? [videoFile] : [],
			rules: [validRequired('请上传视频', 'change')],
			visable(vm) {
				return vm.formData.fields.platform.value === '29';
			},
		},
		tiktokTitle: {
			label: '视频标题',
			placeholder: '请输入视频标题',
			formType: 'sky-textarea',
			value: tiktokTitle || '',
			tips: '标签格式为：#标签内容，前后需用空格与文本隔开',
			visable(vm) {
				return vm.formData.fields.platform.value === '29';
			},
		},
		privacyLevel: {
			label: '隐私状态',
			formType: 'sky-select',
			value: privacyLevel || '',
			options: [],
			visable(vm) {
				return vm.formData.fields.platform.value === '29';
			},
		},
		interaction: {
			label: '互动设置',
			formType: 'sky-checkbox',
			value: interaction || [],
			options: [], // 需要对接
			visable(vm) {
				return vm.formData.fields.platform.value === '29';
			},
		},
		openBrand: {
			label: '商业内容披露',
			formType: 'sky-switch',
			value: openBrand || false,
			visable(vm) {
				return vm.formData.fields.platform.value === '29';
			},
		},
		businessContent: {
			label: '商业内容类型',
			formType: 'sky-checkbox',
			value: businessContent || [],
			// min: 1,
			options: [
				{
					label: '您的品牌',
					value: 1,
				},
				{
					label: '品牌内容',
					value: 2,
					disabled: privacyLevel === 4,
					tip: '品牌内容的可见性不能设为私密。',
					tipDisabled: false,
				},
			],
			visable(vm) {
				return vm.formData.fields.openBrand.value && vm.formData.fields.platform.value === '29';
			},
		},
		firstTip: {
			formType: 'sky-text',
			value: businessContent ? getTipsObj(businessContent).firstTip : '',
			visable(vm) {
				return vm.formData.fields.openBrand.value && vm.formData.fields.platform.value === '29';
			},
			style: {
				fontSize: '12px',
				lineHeight: '12px',
				color: '#909399',
			},
		},
		secondTip: {
			formType: 'sky-text',
			value: businessContent ? getTipsObj(businessContent).secondTip : '',
			visable(vm) {
				return vm.formData.fields.openBrand.value && vm.formData.fields.platform.value === '29';
			},
			style: {
				fontSize: '13px',
			},
		},
		publishTips: {
			formType: 'sky-text',
			value: '*确认后内容将发布至您的TikTok主页',
			style: {
				fontSize: '13px',
				textAlign: 'right',
			},
			visable(vm) {
				return vm.formData.fields.platform.value === '29';
			},
		},
	};
}

// 生成提示信息对象
function getTipsObj(val) {
	// 提取常量，增强可读性和可维护性
	const BRAND_FLAG = 1; // 品牌标识
	const BRAND_CONTENT_FLAG = 2; // 品牌内容标识
	const MUSIC_USAGE_LINK = `
    <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en"
       target="_blank" rel="noopener noreferrer">
      音乐使用确认
    </a>
  `;
	const BRAND_POLICY_LINK = `
    <a href="https://www.tiktok.com/legal/page/global/bc-policy/en"
       target="_blank" rel="noopener noreferrer">
      品牌内容政策
    </a>
  `;
	const COMPLIANCE_PREFIX = 'TikTok合规声明：发布即表示您同意 TikTok 的';

	// 简化条件判断
	const hasBrand = val.includes(BRAND_FLAG);
	const hasBrandContent = val.includes(BRAND_CONTENT_FLAG);

	// 生成tip1：合并重复的逻辑分支
	let tip1 = '';
	if (hasBrand && !hasBrandContent) {
		tip1 = '您的照片/视频将被标记为“推广内容”';
	} else if (hasBrandContent) {
		// 合并 !hasBrand && hasBrandContent 和 hasBrand && hasBrandContent 分支
		tip1 = '您的照片/视频将被标记为“付费合作”';
	}

	// 生成tip2：通过拼接常量减少重复代码
	let tip2 = '';
	if (hasBrand || hasBrandContent) {
		// 只有存在标识时才生成合规声明
		let linkContent = '';
		if (hasBrand && !hasBrandContent) {
			linkContent = MUSIC_USAGE_LINK;
		} else {
			// 包含品牌内容的情况（无论是否包含品牌）
			linkContent = `${BRAND_POLICY_LINK} 和 ${MUSIC_USAGE_LINK}`;
		}

		// 拼接最终的HTML字符串
		tip2 = `
      <div class="compliance-notice">
        ${COMPLIANCE_PREFIX}
        ${linkContent}
      </div>
    `;
	}

	return {
		firstTip: tip1,
		secondTip: tip2,
	};
}

// 根据选择客户拉取服务单列表
async function productkeyword(customerId) {
	let res = await mediafax.getMediafaxSubject({
		customerId,
	});
	return res;
}

/**
 * 加载TikTok交互设置、隐私等级下拉选项
 * @param {string|number} serviceSiteId 选中的serviceId值
 * @param {object} vm vue实例
 */
async function loadTiktokConfigOptions(serviceSiteId, vm) {
	const [interactionResult, privacyResult] = await Promise.all([
		tweetsAPI.tiktokInteractionSettings({
			serviceSiteId,
		}),
		tweetsAPI.tiktokPrivacyLevels({
			serviceSiteId,
		}),
	]);

	vm.formData.fields.interaction.options = interactionResult.data.map(item => ({
		label: item.label,
		value: item.field,
		disabled: !item.enabled,
	}));

	vm.formData.fields.privacyLevel.options = privacyResult.data.map(item => ({
		label: item.label,
		value: item.code,
	}));
}

// 处理表单变化
async function valueChange(vm, field) {
	let { itemName, value } = field;
	let { formData } = vm;
	let { businessContent } = formData.fields;

	if (itemName === 'customerId') {
		let res = await productkeyword(value);
		vm.formData.fields.serviceId.value = '';
		vm.formData.fields.serviceId.options = res.data;
	}

	if (itemName === 'serviceId') {
		// 根据选中id找到服务选项
		const selectedService = vm.formData.fields.serviceId.options.find(
			option => option.id === value
		);

		if (!selectedService) return;

		const { hasSnsPlusPermission } = selectedService;
		if (hasSnsPlusPermission) {
			vm.formData.fields.platform.visable = () => true;

			await loadTiktokConfigOptions(value, vm);
		} else {
			vm.formData.fields.platform.value = '';
			vm.formData.fields.platform.visable = () => false;
		}
	}

	if (itemName === 'openBrand') {
		vm.formData.fields.businessContent.value = [];
	}

	if (itemName === 'privacyLevel') {
		const hasBrand = businessContent.value.includes(2);
		if (value === 4) {
			vm.formData.fields.businessContent.options[1].disabled = true;
			vm.formData.fields.businessContent.options[1].tipDisabled = false;
			if (hasBrand) {
				vm.$message.warning('品牌内容不能设为私密，隐私已自动调整为公开。');
				vm.formData.fields.privacyLevel.value = 1;
			}
		} else {
			vm.formData.fields.businessContent.options[1].disabled = false;
			vm.formData.fields.businessContent.options[1].tipDisabled = true;
		}
	}

	if (itemName === 'businessContent') {
		let tipsObj = getTipsObj(value);
		let { firstTip, secondTip } = tipsObj;
		vm.formData.fields.firstTip.value = firstTip;
		vm.formData.fields.secondTip.value = secondTip;
		vm.subButtonDisabled = value.length === 0 && formData.fields.openBrand.value;
		vm.subButtonTipText =
			value.length === 0 && formData.fields.openBrand.value ? '请至少选择一种商业内容类型' : '';
	}
}

// // 表单提交
// async function submit(data) {
// 	try {
// 		let params = {};
// 		let { platform, assets } = data;

// 		if (!platform || !platform === '29') {
// 			if (assets && assets.length > 0) {
// 				if (assets[0].type == 'image') {
// 					params.imageFileList = [];
// 					assets.forEach(item => {
// 						params.imageFileList.push({
// 							fileName: item.fileName,
// 							ossName: item.ossName,
// 							url: item.url,
// 						});
// 					});
// 				}
// 				if (assets[0].type == 'video') {
// 					params.videoFile = {
// 						fileName: assets[0].fileName,
// 						ossName: assets[0].ossName,
// 						url: assets[0].url,
// 					};
// 				}
// 			}
// 		} else {
// 			let { videoFile, interaction, openBrand, businessContent } = data;

// 			let obj = Object.assign(videoFile, {})[0];
// 			// 创建URL对象
// 			const urlObj = new URL(obj.url);

// 			// 将协议改为https
// 			urlObj.protocol = 'https:';
// 			// 转为最终URL字符串
// 			obj.url = urlObj.toString();
// 			params.videoFile = obj;

// 			if (interaction.includes('ableComment')) params.ableComment = true;
// 			if (interaction.includes('ableDuet')) params.ableDuet = true;
// 			if (interaction.includes('ableStitch')) params.ableStitch = true;

// 			if (openBrand) {
// 				if (businessContent.includes(1)) params.brandOrganicToggle = true;
// 				if (businessContent.includes(2)) params.brandContentToggle = true;
// 			}
// 		}

// 		params = {
// 			...params,
// 			...data,
// 			platformList: platform ? [platform] : ['26'],
// 		};

// 		this.$emit('confirm');
// 	} catch (error) {
// 		this.$message.error('操作失败');
// 		this.formData.loading = false;
// 	}
// }

// 表单提交
async function submit(data) {
	try {
		const formDataCopy = _.cloneDeep(data);
		const { platform, assets, videoFile, interaction, openBrand, businessContent } =
			formDataCopy || {};
		const params = {};

		// 修正原错误条件：platform 不等于29时走这个分支
		if (platform !== '29') {
			if (Array.isArray(assets) && assets.length > 0) {
				const firstAssetType = assets[0].type;
				if (firstAssetType === 'image') {
					params.imageFileList = assets.map(item => ({
						fileName: item.fileName,
						ossName: item.ossName,
						url: item.url,
					}));
				}
				if (firstAssetType === 'video') {
					const asset = assets[0];
					params.videoFile = {
						fileName: asset.fileName,
						ossName: asset.ossName,
						url: asset.url,
					};
				}
			}
		} else {
			// platform === 29 分支
			if (Array.isArray(videoFile) && videoFile.length > 0) {
				const obj = { ...videoFile[0] }; // 浅拷贝，不修改原对象
				try {
					const urlObj = new URL(obj.url);
					urlObj.protocol = 'https:';
					obj.url = urlObj.toString();
				} catch (_) {
					// url解析失败，保留原值不中断流程
				}
				params.videoFile = obj;
			}

			// 互动权限
			if (Array.isArray(interaction)) {
				params.ableComment = interaction.includes('ableComment');
				params.ableDuet = interaction.includes('ableDuet');
				params.ableStitch = interaction.includes('ableStitch');
			}

			// 品牌开关
			if (openBrand && Array.isArray(businessContent)) {
				params.brandOrganicToggle = businessContent.includes(1);
				params.brandContentToggle = businessContent.includes(2);
			}
		}

		// 合并参数，platformList兜底
		params.platformList = platform ? [platform] : ['26'];

		delete formDataCopy.assets;
		delete formDataCopy.videoFile;
		delete formDataCopy.assets;
		delete formDataCopy.firstTip;
		delete formDataCopy.secondTip;
		delete formDataCopy.publishTips;
		delete formDataCopy.publishTips;
		delete formDataCopy.interaction;
		delete formDataCopy.businessContent;

		Object.assign(params, formDataCopy);

		await tweetsAPI.addTweets(params);
		this.$message.success('发布成功');
		this.$emit('confirm');
	} catch (error) {
		console.error('submit error:', error);
		this.$message.error('发布失败');
	} finally {
		// 无论成功失败，关闭loading，统一处理
		this.formData.loading = false;
	}
}

// 默认关闭方法
function cancel(self) {
	self.$emit('cancel');
}

// 表单开局加载数据处理方法
async function onShowLoad(props) {
	let { customerId } = props;
	let serviceOptions;

	if (customerId) {
		let res = await productkeyword(customerId);
		serviceOptions = res.data;
	}

	return {
		...props,
		serviceOptions,
	};
}

const componentForm = formPanelCreate(
	{
		getFormData,
		submit,
		cancel,
	},
	{
		labelWidth: '130px',
	}
);

export default formDialogCreate({
	name: 'tweetsFormDialog',
	onShowLoad,
	componentForm,
});
</script>

<style scoped lang="scss"></style>
